import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServiceCard from "./ServiceCard";
import RainbowButton from "../shared/RainbowButton";
import { useData } from "../../providers/dataProvider";
import { pageMeta } from "../../config/helmetConfig";
import "./Services.css";
import { updateMetaTags } from "../../utils/metaManager";

export default function Services() {
  const { services } = useData();

  useEffect(() => {
    updateMetaTags(pageMeta.services);
  }, []);

  return (
    <div className="services-page-container">
      <div className="services-brick-background"></div>

      <div className="services-content-section">
        {/* Modern Header Section */}
        <div className="services-header-section">
          <Container>
            <Row className="justify-content-center">
              <Col xs={12}>
                <h1 className="services-title">Our Services</h1>
                <div className="services-intro-card">
                  <p className="services-description">
                    We offer a variety of services from hair color to perms, waxing to
                    beards. Each of our individual stylists and barbers have specific
                    skills that vary, so if there is something specific you are looking
                    for please give the shop a call and we can make sure you are
                    scheduled with the right stylist or barber to complete your dream
                    look. Now Offering Non-Surgical Hair Replacement Systems! Prices
                    vary on colors, extensions and chemical services, please call the
                    shop at (719) 452-1343 with any questions.
                  </p>
                  <div className="services-cta-container">
                    <RainbowButton
                      text="Book Now"
                      href="https://styleemporium.glossgenius.com/booking-flow"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Services Grid Section */}
        <div className="services-grid-section">
          <Container>
            <Row className="services-grid-container">
              {services.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}
